import styled from '@emotion/styled'

export const LinkContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  i { margin-bottom: 1rem; }
  a { display: block; }
`
